import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';
import { HANDLING_PLATFORM_TYPE_SLUG, HANDLING_TOOL_SLUG, LOGISTIC_TASK_LAUNCHER_MANUAL_SLUG, LOGISTIC_TASK_LAUNCHER_SIMPLIFIED_SLUG, LOGISTIC_TASK_LAUNCHER_TYPE_SELECTION_SLUG } from './shared/shared.module';
const title = environment ? environment.appTitle : 'Application Title';

const routes: Routes = [
    // #region rotte con autenticazione
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            ...BaseRoutes.getEntityRoutes(
                title,
                HANDLING_PLATFORM_TYPE_SLUG,
                () => import('./handling-platform-type/handling-platform-type.module').then(m => m.HandlingPlatformTypeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                HANDLING_TOOL_SLUG,
                () => import('./handling-tool/handling-tool.module').then(m => m.HandlingToolModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handlingtooltype',
                () => import('./handling-tool-type/handling-tool-type.module').then(m => m.HandlingToolTypeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handlingunittype',
                () => import('./handling-unit-type/handling-unit-type.module').then(m => m.HandlingUnitTypeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'isohandlingplatform',
                () => import('./iso-handling-platform/iso-handling-platform.module').then(m => m.ISOHandlingPlatformModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticrequest',
                () => import('./logistic-request/logistic-request.module').then(m => m.LogisticRequestModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticrequestitem',
                () => import('./logistic-request-item/logistic-request-item.module').then(m => m.LogisticRequestItemModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logistictaskclassification',
                () => import('./logistic-task-classification/logistic-task-classification.module').then(m => m.LogisticTaskClassificationModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logistictaskconsolesearch',
                () => import('./logistic-task-console-search/logistic-task-console-search.module').then(m => m.LogisticTaskConsoleSearchModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                LOGISTIC_TASK_LAUNCHER_MANUAL_SLUG,
                () => import('./logistic-task-launcher-manual/logistic-task-launcher-manual.module').then(m => m.LogisticTaskLauncherManualModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logistictasklaunchersearch',
                () => import('./logistic-task-launcher-search/logistic-task-launcher-search.module').then(m => m.LogisticTaskLauncherSearchModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                LOGISTIC_TASK_LAUNCHER_SIMPLIFIED_SLUG,
                () => import('./logistic-task-launcher-simplified/logistic-task-launcher-simplified.module').then(m => m.LogisticTaskLauncherSimplifiedModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                LOGISTIC_TASK_LAUNCHER_TYPE_SELECTION_SLUG,
                () => import('./logistic-task-launcher-type-selection-long-op/logistic-task-launcher-type-selection-long-op.module').then(m => m.LogisticTaskLauncherTypeSelectionLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'printer',
                () => import('./printer/printer.module').then(m => m.PrinterModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'qualification',
                () => import('./qualification/qualification.module').then(m => m.QualificationModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'storagezone',
                () => import('./storage-zone/storage-zone.module').then(m => m.StorageZoneModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'storagestructure',
                () => import('./storage-structure/storage-structure.module').then(m => m.StorageStructureModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'storagelocationlongop',
                () => import('./storage-location-long-op/storage-location-long-op.module').then(m => m.StorageLocationLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'stockdatalongop',
                () => import('./stock-data-long-op/stock-data-long-op.module').then(m => m.StockDataLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'userlogistic',
                () => import('./user-logistic/user-logistic.module').then(m => m.UserLogisticModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logistictaskconsoledetail',
                () => import('./logistic-task-console-detail/logistic-task-console-detail.module').then(m => m.LogisticTaskConsoleDetailModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldstockitemslongop',
                () => import('./hand-held-stock-items-long-op/hand-held-stock-items-long-op.module').then(m => m.HandHeldStockItemsLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'choosehandlingtool',
                () => import('./choose-handling-tool/choose-handling-tool.module').then(m => m.ChooseHandlingToolModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logistictaskconsolesplitlongop',
                () => import('./logistic-task-console-split-long-op/logistic-task-console-split-long-op.module').then(m => m.LogisticTaskConsoleSplitLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'chooseprinterlongop',
                () => import('./choose-printer-long-op/choose-printer-long-op.module').then(m => m.ChoosePrinterLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'chooseprinterbackoffice',
                () => import('./choose-printer-backoffice/choose-printer-backoffice.module').then(m => m.ChoosePrinterBackofficeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticconfiguration',
                () => import('./logistic-configuration/logistic-configuration.module').then(m => m.LogisticConfigurationModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldbarcodebalancelongop',
                () => import('./hand-held-barcode-balance-long-op/hand-held-barcode-balance-long-op.module').then(m => m.HandHeldBarcodeBalanceLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticinternaltasklaunchersearchlongop',
                () => import('./logistic-internal-task-launcher-search-long-op/logistic-internal-task-launcher-search-long-op.module').then(m => m.LogisticInternalTaskLauncherSearchLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticloweringtasklaunchersearchlongop',
                () => import('./logistic-lowering-task-launcher-search-long-op/logistic-lowering-task-launcher-search-long-op.module').then(m => m.LogisticLoweringTaskLauncherSearchLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticloweringtasklaunchersimplifiedlongop',
                () => import('./logistic-lowering-task-launcher-simplified-long-op/logistic-lowering-task-launcher-simplified-long-op.module').then(m => m.LogisticLoweringTaskLauncherSimplifiedLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticloweringtasklaunchermanuallongop',
                () => import('./logistic-lowering-task-launcher-manual-long-op/logistic-lowering-task-launcher-manual-long-op.module').then(m => m.LogisticLoweringTaskLauncherManualLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticmovementtasklaunchersimplifiedlongop',
                () => import('./logistic-movement-task-launcher-simplified-long-op/logistic-movement-task-launcher-simplified-long-op.module').then(m => m.LogisticMovementTaskLauncherSimplifiedLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticmovementtasklaunchermanuallongop',
                () => import('./logistic-movement-task-launcher-manual-long-op/logistic-movement-task-launcher-manual-long-op.module').then(m => m.LogisticMovementTaskLauncherManualLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticinventorytasklaunchersimplifiedlongop',
                () => import('./logistic-inventory-task-launcher-simplified-long-op/logistic-inventory-task-launcher-simplified-long-op.module').then(m => m.LogisticInventoryTaskLauncherSimplifiedLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticinventorytasklaunchermanuallongop',
                () => import('./logistic-inventory-task-launcher-manual-long-op/logistic-inventory-task-launcher-manual-long-op.module').then(m => m.LogisticInventoryTaskLauncherManualLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handhelditembarcode',
                () => import('./hand-held-item-barcode/hand-held-item-barcode.module').then(m => m.HandHeldItemBarcodeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'deliveryplansearch',
                () => import('./delivery-plan-search/delivery-plan-search.module').then(m => m.DeliveryPlanSearchModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'deliveryplanaddtasks',
                () => import('./delivery-plan-add-tasks/delivery-plan-add-tasks.module').then(m => m.DeliveryPlanAddTasksModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'deliveryplandetail',
                () => import('./delivery-plan-detail/delivery-plan-detail.module').then(m => m.DeliveryPlanDetailModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'reccomendeditemlocationassociationlongop',
                () => import('./reccomended-item-location-association-long-op/reccomended-item-location-association-long-op.module').then(m => m.ReccomendedItemLocationAssociationLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'workflowinbound',
                () => import('./workflow-inbound/workflow-inbound.module').then(m => m.WorkflowInboundModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'workflowpicking',
                () => import('./workflow-picking/workflow-picking.module').then(m => m.WorkflowPickingModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'workflowlowering',
                () => import('./workflow-lowering/workflow-lowering.module').then(m => m.WorkflowLoweringModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'workflowinventory',
                () => import('./workflow-inventory/workflow-inventory.module').then(m => m.WorkflowInventoryModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'workflowhandling',
                () => import('./workflow-handling/workflow-handling.module').then(m => m.WorkflowHandlingModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'absencereasonlist',
                () => import('./absence-reason-list/absence-reason-list.module').then(m => m.AbsenceReasonListModule)
            ),
            ...BaseRoutes.getDefaultRoutes(
                title,
                environment,
                true
            )
        ],
    ),

    // gestione delle rotte handheld
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldmenu',
                () => import('./hand-held-menu/hand-held-menu.module').then(m => m.HandHeldMenuModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldinboundtaskselector',
                () => import('./hand-held-inbound-task-selector/hand-held-inbound-task-selector.module').then(m => m.HandHeldInboundTaskSelectorModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldinbound',
                () => import('./hand-held-inbound/hand-held-inbound.module').then(m => m.HandHeldInboundModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldpickinglongop',
                () => import('./hand-held-picking-long-op/hand-held-picking-long-op.module').then(m => m.HandHeldPickingLongOpModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldpickingtaskselector',
                () => import('./hand-held-picking-task-selector/hand-held-picking-task-selector.module').then(m => m.HandHeldPickingTaskSelectorModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldhandling',
                () => import('./hand-held-handling/hand-held-handling.module').then(m => m.HandHeldHandlingModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldfreehandlingtaskselector',
                () => import('./hand-held-free-handling-task-selector/hand-held-free-handling-task-selector.module').then(m => m.HandHeldFreeHandlingTaskSelectorModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldinventory',
                () => import('./hand-held-inventory/hand-held-inventory.module').then(m => m.HandHeldInventoryModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handhelddeliverytaskselector',
                () => import('./hand-held-delivery-task-selector/hand-held-delivery-task-selector.module').then(m => m.HandHeldDeliveryTaskSelectorModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handhelddelivery',
                () => import('./hand-held-delivery/hand-held-delivery.module').then(m => m.HandHeldDeliveryModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldfreehandling',
                () => import('./hand-held-free-handling/hand-held-free-handling.module').then(m => m.HandHeldFreeHandlingModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldhandlingtaskselector',
                () => import('./hand-held-handling-task-selector/hand-held-handling-task-selector.module').then(m => m.HandHeldHandlingTaskSelectorModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldinventorytaskselector',
                () => import('./hand-held-inventory-task-selector/hand-held-inventory-task-selector.module').then(m => m.HandHeldInventoryTaskSelectorModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldloweringtaskselector',
                () => import('./hand-held-lowering-task-selector/hand-held-lowering-task-selector.module').then(m => m.HandHeldLoweringTaskSelectorModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'handheldlowering',
                () => import('./hand-held-lowering/hand-held-lowering.module').then(m => m.HandHeldLoweringModule)
            ),
        ],
        () => import('./hand-held-container/components/hand-held-container/hand-held-container.component').then(mod => mod.HandHeldContainerComponent)

    ),
    // #endregion rotte con autenticazione

    // rotte base per la gestione degli errori
    ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
    imports: [
        // TODO Tommy: si potrebbe creare una custom preloadin strategy per precaricare solo le rotte offline
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', paramsInheritanceStrategy: 'always', preloadingStrategy: NoPreloading }),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
